import { FC } from "react";
import { Droppable } from "@hello-pangea/dnd";
import OverviewDragDropColumnItem from "./overviewDragDropColumnItem";
import { TDashboardColumn } from "../types/overview.types";
import { APP_CONFIG } from "../../../constants/constants";

type TOverviewDragDropColumn = {
  columnData: TDashboardColumn;
  droppableId: string;
};

const OverviewDragDropColumn: FC<TOverviewDragDropColumn> = ({
  columnData,
  droppableId,
}) => {
  return (
    <Droppable droppableId={droppableId}>
      {/* change col to columnData?.id */}
      {(provided) => (
        <div className="flex flex-col relative">
          {APP_CONFIG.DEBUG.DISPLAY_VERBOSE && (
            <pre className="absolute top-0 left-0 text-[8px] px-4">{`${columnData?.id}`}</pre>
          )}
          <div
            className="rounded-lg flex flex-col flex-grow" // h-[calc(100vh-300px)] overflow-auto - add these classes to enable scrollbars for every column
            {...provided.droppableProps}
            ref={provided.innerRef}
          >
            {columnData?.colWidgets?.map((widget, index) => (
              <OverviewDragDropColumnItem
                key={`${droppableId}__${index}__${widget.dashboard}__${widget.created_at}`}
                widget={widget}
                index={index}
              />
            ))}
            {provided.placeholder}
          </div>
        </div>
      )}
    </Droppable>
  );
};
export default OverviewDragDropColumn;
